// extracted by mini-css-extract-plugin
export default {"main_container":"four04_main_container__tO1+B","text":"four04_text__A1wVF","btn_solid_grad":"four04_btn_solid_grad__Cfi+L"};